module.exports = __webpack_public_path__ + "img/tcv_parked.9ac3859a.svg";